import * as React from 'react'

/**
 * Whether the reader has asked the system for reduced motion.
 *
 * For effects CSS cannot reach — a WebGL shader's speed, a rAF loop — where the
 * `motion-reduce:` variant and `@media (prefers-reduced-motion)` have nothing to
 * hook onto. Anything expressible in CSS should keep using those.
 *
 * It tracks changes rather than reading once: the setting can be toggled while the
 * app is open, and an effect that only honours it on mount would keep running.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduce, setReduce] = React.useState(false)

  React.useEffect(() => {
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)')
    const onChange = () => setReduce(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return reduce
}
